export default {
  index: [
    {
      path: '/zkpartnerannual',
      component: resolve => require(['./zkpartnerannualIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkpartner_annual_ranking/_router.js